// extracted by mini-css-extract-plugin
module.exports = {"chatSliderContainer":"az_-Rb","chatSliderImgContent":"az_-Sb","liveChat":"az_-Tb","sr":"az_-Ub","chatBtn":"az_-Vb"};